import Vue from 'vue'
let mixin = {
  isAssetTypeAnImage(val) {
    return (
      [
        "png",
        "jpg",
        "jpeg",
        "bmp",
        "gif",
        "webp",
        "psd",
        "svg",
        "tiff"
      ].indexOf(val.toLowerCase()) !== -1
    );
  },
  isPhone(val) {
    return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(val);
  },
  isDecimal(val) {
    return /(^[\-0-9][0-9]*(.[0-9]+)?)$/.test(val);
  },
  isNumber(val) {
    return /(^[\-0-9][0-9]*([0-9]+)?)$/.test(val);
  },
  isMail(val) {
    return /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val);
  },
  isUrl(url) {
    return this.checkUrl(url);
  },
  checkUrl(url) {
    //url= 协议://(ftp的登录信息)[IP|域名](:端口号)(/或?请求参数)
    var strRegex =
      "^((https|http|ftp)://)?" + //(https或http或ftp):// 可有可无
      "(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + //ftp的user@  可有可无
      "(([0-9]{1,3}\\.){3}[0-9]{1,3}" + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
      "|" + // 允许IP和DOMAIN（域名）
      "(localhost)|" + //匹配localhost
      "([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
      "\\w+\\." + // 一级域名 -英文或数字  加上.
      "[a-zA-Z]{1,6})" + // 顶级域名- 1-6位英文
      "(:[0-9]{1,5})?" + // 端口- :80 ,1-5位数字
      "((/?)|" + // url无参数结尾 - 斜杆或这没有
      "(/[\\w_!~*'()\\.;?:@&=+$,%#-]+)+/?)$"; //请求参数结尾- 英文或数字和[]内的各种字符
    var re = new RegExp(strRegex, "i"); //i不区分大小写
    //将url做uri转码后再匹配，解除请求参数中的中文和空字符影响
    if (re.test(encodeURI(url))) {
      return true;
    }
    return false;
  },
  matchUrlIp(url, ip) {
    //url使用是否使用的当前ip
    if (!url || !ip) {
      return false;
    }
    return url.indexOf(ip.replace("https://", "").replace("http://", "")) >= 0;
  },
  getImgSrc(src, httpUrl) {
    if (this.isUrl(src)) {
      return src;
    }
    if (httpUrl) {
      return httpUrl + src;
    }
    return src;
  },
  previewImg(src, httpUrl) {
    //图片预览，目前只支持单图片预览
    if (src && !this.isUrl(src) && httpUrl) {
      if (
        src.substr(0, 1) == "/" &&
        httpUrl.substr(httpUrl.length - 1, 1) == "/"
      ) {
        src = src.substr(1);
      }
      src = httpUrl + src;
    }
    let id = "vol-preview";
    let $div = document.getElementById(id);
    if (!$div) {
      $div = document.createElement("div");
      $div.setAttribute("id", "vol-preview");
      let $mask = document.createElement("div");
      $mask.style.position = "absolute";
      $mask.style.width = "100%";
      $mask.style.height = "100%";
      $mask.style.background = "black";
      $mask.style.opacity = "0.6";
      $div.appendChild($mask);
      $div.style.position = "fixed";
      $div.style.width = "100%";
      $div.style.height = "100%";
      // $div.style.overflow = "scroll";
      $div.style.top = 0;
      $div.style["z-index"] = 9999999;
      let $img = document.createElement("img");
      $img.setAttribute("class", "vol-preview-img");
      $img.style.position = "absolute";
      $img.style.top = "50%";
      $img.style.left = "50%";
      $img.style["max-width"] = "90%";
      $img.style["max-height"] = "90%";
      $img.style.transform = "translate(-50%,-50%)";
      // $img.src = src;
      $img.setAttribute("src", src);
      $div.appendChild($img);
      $div.addEventListener("click", function() {
        this.style.display = "none";
      });
      document.body.appendChild($div);
      return;
    }
    let $img1 = document.body
      .appendChild($div)
      .querySelector(".vol-preview-img");
    // img.src = src;
    $img1.setAttribute("src", src);
    $div.style.display = "block";
  },
  //下载文件 $element 标签, url完整url, fileName 文件名, header 以key/value传值
  //backGroundUrl 后台url，如果后台url直接从后台下载，其他全部通过点击a标签下载
  dowloadFile(url, fileName, header, backGroundUrl) {
    if (!url) {
      alert("此文件没有url不能下载");
      return;
    }
    let $element = document.getElementById("dowonloadfile-a");
    if (!$element) {
      $element = document.createElement("a");
      $element.download = fileName;
      $element.setAttribute("id", "dowonloadfile-a");
      document.body.append($element);
    }
    //url为一个完整的地址，并且不是后台api的地址，直接点击a标签下载
    // if (this.isUrl(url) && !this.matchUrlIp(url, backGroundUrl)) {
    // $element.href = url;
    // $element.click();
    // return;
    //  }

    if (!this.isUrl(url)) {
      if (!this.isUrl(backGroundUrl + url)) {
        console.log("文件路径不正确");
        alert("文件路径不正确");
        return;
      }
      url = backGroundUrl + url;
    }
    $element.href = url;
    $element.click();
    return;

    //通过后台api服务器下载
    if (!this.isUrl(url)) {
      if (!this.isUrl(backGroundUrl + url)) {
        alert("当前下载的文件url【" + url + "】不正确");
        return;
      }
      url = backGroundUrl + url;
    }
    let xmlResquest = new XMLHttpRequest();
    xmlResquest.open("GET", url, true);
    xmlResquest.setRequestHeader("Content-type", "application/json");
    if (header && typeof header == "object") {
      for (const key in header) {
        xmlResquest.setRequestHeader(key, header[key]);
      }
    }

    xmlResquest.responseType = "blob";
    xmlResquest.onload = function(oEvent) {
      if (xmlResquest.status != 200) {
        return alert("没有下载到此文件的信息");
      }
      let content = xmlResquest.response;
      $element.download = fileName;
      let blob = new Blob([content]);
      $element.href = URL.createObjectURL(blob);
      $element.click();
    };
    xmlResquest.send();
  },
  downloadIamge(imgsrc, name) {
    //下载图片地址和图片名
    var image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function() {
      var canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      var context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

      var a = document.createElement("a"); // 生成一个a元素
      var event = new MouseEvent("click"); // 创建一个单击事件
      a.download = name || "photo"; // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
    };
    image.src = imgsrc;
  },
  //对各种文件下载，转换blob类型
  fileLinkToStreamDownload(url, fileName, type) {
    let xhr = new XMLHttpRequest();
    xhr.open("get", url, true);
    xhr.setRequestHeader("Content-Type", `application/${type}`);
    xhr.responseType = "blob";
    let _this = this;
    xhr.onload = function() {
      if (this.status == 200) {
        //接受二进制文件流
        var blob = this.response;
        let ua = navigator.userAgent;
        if (ua.indexOf("Trident") != -1 && ua.indexOf("Windows") != -1) {
          // IE内核 并且  windows系统 情况下 才执行;
          navigator.msSaveBlob(blob, fileName);
        } else if (ua.indexOf("Firefox") > -1) {
          //火狐兼容下载
          _this.downloadExportFile(blob, fileName, type);
        } else {
          //谷歌兼容下载
          _this.downloadExportFile(blob, fileName, type);
        }
      }
    };
    xhr.send();
  },
  downloadExportFile(blob, tagFileName, fileType) {
    let downloadElement = document.createElement("a");
    let href = blob;
    if (typeof blob == "string") {
      downloadElement.target = "_blank";
    } else {
      href = window.URL.createObjectURL(blob); //创建下载的链接
    }
    downloadElement.href = href;
    downloadElement.download = tagFileName; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    if (typeof blob != "string") {
      window.URL.revokeObjectURL(href); //释放掉blob对象
    }
  },
  /**
   * @description: 文件流下载
   * @param {*} response 接口返回的文件流
   * @author: MarkLin
   */
  blobDownload(response,fileName) {
    if (!response) {
      return
    }
    if (!fileName) {
      console.warn('请传入文件名，如：图1.png，文档.doc等')
      return message.error('未获取到文件名！')
    }
    const blob = response
    const a = document.createElement('a')
    let binaryData = [];
    let type = 'chartset=UTF-8'
    binaryData.push(blob);
    let URL = window.URL || window.webkitURL
    const url = URL.createObjectURL(new Blob(binaryData,{type:type}));
    a.href = url
    a.download = fileName
    a.click()
    window.URL.revokeObjectURL(url)
  },
  //blob类型接口（如文件导出）失败时，解析响应体中的报错信息并提示
  blobErrorTip(error) {
    //HTTP 200 + JSON（code!=200）的业务错误已在响应拦截器提示过，这里不再弹
    if (error && error.blobTipped) {
      return
    }
    const resp = error && error.response
    if (!resp) {
      //无响应时只有真网络错误/超时（axios错误带request）才提示；
      //不带request的多为401/424时全局拦截器return false后then里取值抛出的TypeError，全局已提示过，这里不再弹
      if (error && error.request) {
        Vue.prototype.$message.error('网络错误' + (error.message ? `：${error.message}` : ''))
      }
      return
    }
    if (resp.data instanceof Blob) {
      const reader = new FileReader()
      reader.onload = () => {
        let msg = `${resp.status} ${resp.statusText}`
        try {
          const json = JSON.parse(reader.result)
          if (json && json.msg) msg = json.msg
        } catch (e) { /*响应体不是JSON时仅提示状态码*/ }
        Vue.prototype.$message.error(msg)
      }
      reader.readAsText(resp.data, 'utf-8')
    } else if (resp.data && resp.data.msg) {
      Vue.prototype.$message.error(resp.data.msg)
    } else {
      Vue.prototype.$message.error(`${resp.status} ${resp.statusText}` || '网络错误')
    }
  }
};
export default mixin;



// WEBPACK FOOTER //
// ./src/mixin/mixin.js